import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TweenOne from 'rc-tween-one';
import { Row, Col, Popover, Button, Space, Image } from 'antd';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '@/utils';
import { ArrowRightOutlined } from '@ant-design/icons';
import ApplyTry from './ApplyTry';

function Content7(props) {
  const { dataSource, isMobile, ...restProps } = props;
  const { t, i18n } = useTranslation();

  const getBlockChildren = (data) =>
    data.map(($item) => {
      const { ...item } = $item;
      const { title, img, content, name } = item;
      ['title', 'img', 'content'].forEach((key) => delete item[key]);
      return (
        <li key={item.name} {...item}>
          <span {...img}>
            <img src={img.children} width="100%" alt="img" />
          </span>
          <h2 {...title}>
            {t(title.children)}
            {name === 'block3' &&
              <Space size={35}>
                <Popover style={{ padding: 0 }}
                         content={<img src={require('@/assets/image/qrcode.dib')} />}>
                  <img className="qr-code" src={require('@/assets/image/wechat.png')} alt="icon" />
                </Popover>
                <Button style={{ transform: 'translateY(3px)' }} href="https://www.liepin.com/company-jobs/9400925/"
                        target="_blank" rel="noreferrer" shape="round" type="link">{t('contact.applyPosition')}
                  <ArrowRightOutlined /></Button>
              </Space>
            }
          </h2>
          <div {...content}>{t(content.children)}</div>
        </li>
      );
    });
  const ulChildren = getBlockChildren(dataSource.block.children);
  const queue = isMobile ? 'bottom' : 'left';
  const imgAnim = isMobile
    ? {
      y: 30,
      opacity: 0,
      delay: 600,
      type: 'from',
      ease: 'easeOutQuad'
    }
    : {
      x: 30,
      opacity: 0,
      type: 'from',
      ease: 'easeOutQuad'
    };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <OverPack {...dataSource.OverPack} component={Row}>
        <QueueAnim
          key="text"
          type={queue}
          leaveReverse
          ease={['easeOutQuad', 'easeInQuad']}
          {...dataSource.textWrapper}
          component={Col}
        >
          <div key="title" {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map((item, index) => getChildrenToRender(item, index, t))}
            <h2 className="sub-title">CONTACT US</h2>
            <Button type="primary" onClick={showModal}>{t('contact.applyTry')}</Button>
          </div>
          <QueueAnim
            component="ul"
            key="ul"
            type={queue}
            ease="easeOutQuad"
            {...dataSource.block}
          >
            {ulChildren}
          </QueueAnim>
        </QueueAnim>
        <TweenOne
          key="img"
          animation={imgAnim}
          resetStyle
          {...dataSource.img}
          component={Col}
        >
          <Image src={require(`@/assets/image/${dataSource.img.children}${i18n.language === 'en' ? '_en' : ''}.png`)}
                 width="100%" alt="img" />
        </TweenOne>
      </OverPack>

      <ApplyTry
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
}

export default Content7;
